import { render, staticRenderFns } from "./RemarkTable.vue?vue&type=template&id=eefcee0a&"
import script from "./RemarkTable.vue?vue&type=script&lang=js&"
export * from "./RemarkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports